var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoansGeneratedInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H11V7H13V1Z",
    fill: "#4F4F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L12 0L9 3H15Z",
    fill: "#4F4F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.923 3.52426L3.50879 4.93848L7.28474 8.71442L8.69895 7.30021L4.923 3.52426Z",
    fill: "#4F4F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74977 3.51953H3.50977V7.75952L7.74977 3.51953Z",
    fill: "#4F4F4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11H17V13H23V11Z",
    fill: "#4F4F4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L24 12L21 9V15Z",
    fill: "#4F4F4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H1V13H7V11Z",
    fill: "#4F4F4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9L0 12L3 15V9Z",
    fill: "#4F4F4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0645 3.51409L15.2886 7.29004L16.7028 8.70425L20.4787 4.92831L19.0645 3.51409Z",
    fill: "#4F4F4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4798 7.75952V3.51953H16.2397L20.4798 7.75952Z",
    fill: "#4F4F4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0098C11.4067 15.0098 10.8267 14.8338 10.3333 14.5041C9.83996 14.1745 9.45545 13.706 9.22838 13.1578C9.00132 12.6096 8.94188 12.0064 9.05764 11.4245C9.17339 10.8426 9.45913 10.308 9.87868 9.88843C10.2982 9.46887 10.8328 9.18317 11.4147 9.06741C11.9967 8.95166 12.5999 9.01106 13.1481 9.23813C13.6962 9.46519 14.1648 9.8497 14.4944 10.343C14.824 10.8364 15 11.4164 15 12.0098C15 12.8054 14.6839 13.5685 14.1213 14.1311C13.5587 14.6937 12.7957 15.0098 12 15.0098ZM12 11.0098C11.8022 11.0098 11.6089 11.0684 11.4444 11.1783C11.28 11.2882 11.1518 11.4443 11.0761 11.6271C11.0004 11.8098 10.9806 12.0109 11.0192 12.2048C11.0578 12.3988 11.153 12.577 11.2929 12.7169C11.4328 12.8567 11.6109 12.952 11.8049 12.9905C11.9989 13.0291 12.2 13.0093 12.3827 12.9336C12.5654 12.8579 12.7216 12.7298 12.8315 12.5653C12.9414 12.4009 13 12.2075 13 12.0098C13 11.7445 12.8946 11.4902 12.7071 11.3026C12.5196 11.1151 12.2652 11.0098 12 11.0098Z",
    fill: "#4F4F4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.0098H15V19.0098C15 18.7445 14.8946 18.4902 14.7071 18.3026C14.5196 18.1151 14.2652 18.0098 14 18.0098H10C9.73478 18.0098 9.48041 18.1151 9.29288 18.3026C9.10534 18.4902 9 18.7445 9 19.0098V22.0098H7V19.0098C7 18.2141 7.31605 17.451 7.87866 16.8884C8.44127 16.3258 9.20435 16.0098 10 16.0098H14C14.7956 16.0098 15.5587 16.3258 16.1213 16.8884C16.6839 17.451 17 18.2141 17 19.0098V22.0098Z",
    fill: "#4F4F4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansGeneratedInactive);
export default __webpack_public_path__ + "static/media/loans-generated-inactive.11e07fa3677f493f51eca32ed5e26a70.svg";
export { ForwardRef as ReactComponent };